import { render } from "./DeansReport.vue?vue&type=template&id=f6e5c958"
import script from "./DeansReport.vue?vue&type=script&lang=js"
export * from "./DeansReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__